import { useState } from "react";
import "./Form.scss";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
interface FormProps {
  data: any;
  setView(data: any): void;
}
const Form: React.FC<FormProps> = ({ data, setView }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    from_name: "",
    email_from: "",
    message: "",
  });
  const sendEmail = (e: any) => {
    setIsLoading(true);
    if (
      form.email_from === "" ||
      form.from_name === "" ||
      form.message === ""
    ) {
      toast.info("Please make sure the fields are not empty");
    } else {
      e.preventDefault();
      emailjs
        .sendForm(
          "service_flw6e2l",
          "template_cue2h3d",
          e.target,
          "Kia0B6DAhlBSHw3z3"
        )
        .then(
          function (response) {
            setView("");
            //toast.success("Your email was sent successfully");
            setIsLoading(true);
          },
          function (error) {
            toast.error("Something went wrong, please try again");
            setIsLoading(true);
          }
        )
        .catch((e) => {
          toast.error("Something went wrong, please try again");
          setIsLoading(true);
        });
    }
  };
  return (
    <form className="form-layout" onSubmit={sendEmail}>
      <div className="form-layout__input-group">
        <span>_name:</span>
        <input
          name="from_name"
          onChange={(e) =>
            setForm({ ...form, [e.target.name]: e.target.value })
          }
          autoComplete="off"
          placeholder="write your name"
          type="text"
          value={form.from_name}
        />
      </div>
      <div className="form-layout__input-group">
        <span>_email:</span>
        <input
          name="email_from"
          onChange={(e) =>
            setForm({ ...form, [e.target.name]: e.target.value })
          }
          autoComplete="off"
          placeholder="write your email"
          type="text"
          value={form.email_from}
        />
      </div>
      <div className="form-layout__input-group">
        <span>_message:</span>
        <textarea
          name="message"
          placeholder="write your message"
          onChange={(e) =>
            setForm({ ...form, [e.target.name]: e.target.value })
          }
          autoComplete="off"
          value={form.message}
        />
      </div>
      <button
        disabled={isLoading}
        type="submit"
        style={isLoading ? { opacity: "0.5" } : {}}
        className="form-layout__submit-btn"
      >
        submit-message {isLoading && <span className="loader"></span>}
      </button>
    </form>
  );
};
export default Form;
